<template>
  <div class="set-people">
    <div class="contentItem">
      <div class="item-title">
        {{ name }}
        <span class="require-flag" v-if="isRequired">*</span>
      </div>
      <select-people
        ref="originator"
        v-model="people"
        v-bind="$attrs"
        class="mTop10"
        :app-id="appId"
        @addMail="addMails"
        :mail-list="mails"
        :emailDefs="emailDefs"
      ></select-people>
    </div>
  </div>
</template>

<script>
import SelectPeople from "@/components/Workflow/SelectPeople"
import { transOldExpr } from "@/utils/workFlow"
export default {
  name: "set-people",
  components: {
    SelectPeople
  },
  props: {
    flowInfo: Object,
    name: String,
    isRequired: {
      type: Boolean,
      default: true
    },
    appId: String
  },
  data() {
    return {
      people: "",
      mails: [],
      emailDefs: []
    }
  },
  methods: {
    init() {
      this.people = this.flowInfo.data.candidates
        .map(candidate => {
          candidate.code = transOldExpr(candidate.code)
          return candidate
        })
        .concat(this.flowInfo.extra?.emailDefsExtra)
      this.mails = this.flowInfo.data.mailMessage?.emails
      this.emailDefs = this.flowInfo.data.mailMessage?.emailDefs
    },
    addMails(mails) {
      this.mails = mails
      this.$emit("addMail", mails)
    },
    setValue() {
      let people = this.people.filter(p => p.type !== "mail")
      let emailDefs = this.people.filter(p => p.type === "mail")
      this.$emit("addEmailDefs", emailDefs)
      Object.assign(this.flowInfo.data, {
        candidates: people
      })
      !this.flowInfo.extra && (this.flowInfo.extra = {})
      if (this.name != "选择@人员")
        Object.assign(this.flowInfo.extra, {
          candidates: people.reduce((acc, cur, index) => {
            if (index == 0) acc = cur.label
            else acc = acc + "，" + cur.label
            return acc
          }, "")
        })
    },
    output() {
      if (this.isRequired && !this.people?.length && !this.mails?.length)
        return {
          result: false,
          msg: this.dataRange.includes("mail") ? "未选择人员或邮箱！" : "未选择人员！"
        }
      this.setValue()
      return { result: true }
    }
  }
}
</script>

<style lang="scss" scoped>
.set-people {
  .item-title {
    display: flex;
    height: 16px;
    font-weight: bold;
    .require-flag {
      color: red;
      font-size: 22px;
      position: relative;
      bottom: 4px;
      left: 5px;
    }
  }
}
</style>
